import { SxProps, Theme } from '@mui/material';
import MuiBadge, { BadgeProps as MuiBadgeProps } from '@mui/material/Badge';
import * as React from 'react';

import { enumType, makeEnum, withVersion } from '../utils';

export type BadgeProps = MuiBadgeProps;

const variants = [
    'dot',
    'standard',
    'medium'
] satisfies MuiBadgeProps['variant'][];

export const BadgeVariant = makeEnum(...variants);
export type BadgeVariant = enumType<typeof BadgeVariant>;

export const Badge = withVersion((props: BadgeProps) => {
    const { sx = {} } = props;

    const variantClasses = variants.reduce(
        (acc, variant): SxProps<Theme> => ({
            ...acc,
            [`.MuiBadge-${variant}`]: ({ components }) => {
                switch (variant) {
                    case 'medium':
                        return components?.badge?.[`label-${variant}`] ?? {};
                    case 'dot':
                    case 'standard':
                        return {};
                }
            }
        }),
        {} as SxProps<Theme>
    );

    return (
        <MuiBadge
            data-role="badge"
            {...props}
            sx={
                {
                    ...variantClasses,
                    ...sx
                } as SxProps<Theme>
            }
        />
    );
}, '1.0.0');
